import { Button } from '@mui/joy';
import { CaretDown } from '@phosphor-icons/react';

/**
 * «Показать ещё N» под выдачей поиска.
 *
 * Поиск сознательно не сделан бесконечной лентой: человек ищет что-то
 * конкретное, и если нужного нет в первой пятёрке, чаще правильнее уточнить
 * запрос, чем листать. Кнопка — компромисс: следующая страница по явному
 * действию, а не сама собой при прокрутке.
 *
 * @param {number} count - сколько догрузится за нажатие
 * @param {boolean} loading
 * @param {Function} onClick
 */
export default function ShowMoreButton({ count = 5, loading = false, onClick = () => { } }) {
    return (
        <Button
            variant="soft"
            color="neutral"
            fullWidth
            loading={loading}
            onClick={onClick}
            endDecorator={!loading && <CaretDown size={16} />}
            sx={{ mt: 2, borderRadius: '999px', py: 1.25, maxWidth: 400, mx: 'auto', display: 'flex' }}
        >
            Показать ещё {count}
        </Button>
    );
}
